module.exports = __webpack_public_path__ + "static/media/insuranceClaim1.8edd9278.svg";